import { AfterViewInit, ElementRef, EventEmitter, OnDestroy, OnInit, QueryList } from '@angular/core';
import { TopLevelPatientData } from '../../models/TopLevelPatientData';
import { from, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScriptInjectorService } from 'src/app/core/services/script-injector.service';
import { select, Store } from '@ngrx/store';
import * as fromAuth from '../../../auth/reducers';
import { map } from 'rxjs/operators';
import { ShowNewConversationToastV3 } from 'src/app/messagingV3/legacy/actions/new-message.actions';
var PatientTopLevelComponent = /** @class */ (function () {
    function PatientTopLevelComponent(_store, _scriptInjector) {
        this._store = _store;
        this._scriptInjector = _scriptInjector;
        this.openNewMessage = new EventEmitter();
        this.openNewVideoCall = new EventEmitter();
        this._subscriptions = new Subscription();
    }
    PatientTopLevelComponent.prototype.ngOnInit = function () {
        this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
        this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
        this.useV3Messaging$ = this._store.pipe(select(fromAuth.getMessagingV3Enabled), map(function (enabled) { return (enabled !== undefined ? enabled : false); }));
        this.clinicMessagingLoaded$ = from(this._scriptInjector
            .loadScript('salve-clinic-messaging', environment.messagingComponentUrl)
            .then(function () { return true; })
            .catch(function () { return false; }));
    };
    PatientTopLevelComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var handler = this.onConversationCreated.bind(this);
        this._subscriptions.add(this.createConversationComponents.changes.subscribe(function () {
            var component = _this.createConversationComponents.first;
            component.nativeElement.addEventListener('conversation-created', handler);
        }, function (_error) { }, function () {
            _this.createConversationComponents.forEach(function (component) {
                component.nativeElement.removeEventListener('conversation-created', handler);
            });
        }));
    };
    PatientTopLevelComponent.prototype.onConversationCreated = function (event) {
        if (event.payload && event.payload.conversationId) {
            this._store.dispatch(new ShowNewConversationToastV3({
                conversationId: event.payload.conversationId,
                folderId: event.payload.folderId,
                patients: event.payload.patients
            }));
        }
    };
    PatientTopLevelComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.unsubscribe();
    };
    return PatientTopLevelComponent;
}());
export { PatientTopLevelComponent };
